import { ListenEvent } from './app/Globals';
import { GetDomain, UrlSegments, MergeObject } from './app/Helpers/index';
import { WaitForElementToDisplay } from './app/Helpers/WaitForElementToDisplay';
import { SDBreadcrumbs, SDListItem, StructuredDataModelFactory } from './app/Services/StrucuredData/index';
import { InfoPages, MyAccountRoutes, ProductRoutes, SalesPages } from './routes/index';

let domain = GetDomain();
let root = UrlSegments(0);

export class Routes {

    public static Resolve = new Promise(() => {
        console.group("Initializing routes...");

        if (window.Model) {
            if (window.Model.Slides && window.Model.Testimonials) {
                import('./app/ViewModels/Home' /* webpackMode: "eager", webpackChunkName: "homepage" */).then((viewModel) => {
                    console.info("Initializing HomeVM...")

                    WaitForElementToDisplay(".image-rows", 300, () => {
                        document.querySelector('.image-rows').removeAttribute('hidden');
                    });

                    new viewModel.HomeVM(window.Model);
                }).then(() => {
                    if (window.Model.Featured) {
                        import('./app/ViewModels/Products/CategoryGroup' /* webpackChunkName: "category-group" */).then((viewModel) => {
                            console.info("Initializing Featured Item VM...")
                            const vm = new viewModel.CategoryVM();
                            let newVM = Object.assign({}, window.vm, vm);

                            window.vm = newVM;

                            WaitForElementToDisplay("#featured-items-grid", 300, () => {
                                ko.applyBindings(window.vm, document.getElementById('featured-items-grid'));
                                new ListenEvent.clickJumpToTop();
                            });

                            console.info("Featured Item VM bound");
                        });
                    }
                });
            }
        }

        if (root === "Account") {

            let breadcrumbItemRoot = new SDListItem(domain + "/Account/", "Account", 1);

            function makeAccountPageBreadcrumbs(label: string) {
                let breadcrumbItem = new SDListItem(domain + window.location.pathname, label, 2);
                let breadcrumbs = new SDBreadcrumbs([breadcrumbItemRoot, breadcrumbItem]);
                let sdModelFactory = new StructuredDataModelFactory();

                sdModelFactory.AddSchema(breadcrumbs);
                sdModelFactory.GenerateBreadcrumbs(breadcrumbs);
            }

            if (UrlSegments(1) === "Sign-In") {
                $(() => {
                    makeAccountPageBreadcrumbs("Sign-In");
                })
            }

            if (UrlSegments(1) === "Register") {
                $(() => {
                    makeAccountPageBreadcrumbs("Register");
                })

                import('./app/ViewModels/Account/Register' /* webpackChunkName: "homepage" */).then((viewModel) => {
                    console.info("Initializing RegisterAccountVM...");

                    let vm = ko.validatedObservable(new viewModel.RegisterAccountVM(window.Model))();
                    window.vm = vm;

                    WaitForElementToDisplay("#registration-form", 300, () => {
                        ko.applyBindings(vm, document.getElementById('registration-form'))
                    });
                    console.info("RegisterAccountVM bound");
                });
            }
        }

        if (root === "MyAccount") {
            Routes.MyAccount
        }

        if (root === "products" || "Search") {
            Routes.ProductRoutes
        }

        if (root === "ItemList") {
            Routes.ItemLists;
        }

        if (root === "Info") {
            Routes.InfoPages;
        }

        if (root === "SalesManager" || "SalesRep") {
            Routes.SalesPages;
        }

        if (root === "Campaign") {
            if (UrlSegments(1) === "Sector") {
                import('./app/ViewModels/Campaign/Sector' /* webpackChunkName: "campaign-by-sector" */).then((viewModel) => {
                    window.vm = new viewModel.CampaignBySectorVM();
                    ko.applyBindings(window.vm, document.getElementById('contact-account-manager'));
                });
            }
        }

        console.debug("UrlSegments", { root: root, segments: UrlSegments() });

        console.info("Routes initialized");
        console.groupEnd();
    })

    public static ProductRoutes = ProductRoutes;

    public static InfoPages = InfoPages;

    public static MyAccount = MyAccountRoutes;

    public static ItemLists = new Promise(() => {


        if (root !== "ItemList") {
            return;
        }

        function InitVM() {
            console.group("Initializing ItemList VM...")
            import('./app/ViewModels/Products/ItemList' /* webpackChunkName: "item-list" */).then((viewModel) => {
                (<any>window).DataLoaded = ko.observable(false);

                let Model = window.Model;
                let vm = new viewModel.ItemList(Model.SupplyLists, Model.ParamID);
                window.vm = vm;

                WaitForElementToDisplay("#item-list", 300, () => {
                    ko.applyBindings(vm, document.getElementById('item-list'))
                });
                console.info("ItemLists VM bound");
            });
        }

        ListenEvent.WaitForCartVM.then(() => {
            InitVM();
        })
    });

    public static SalesPages = SalesPages;
}